<template>
  <div class="container bottom information">

    <div class="header bottom-shadow">
      <label v-show="!showAdminContent">Event Settings</label>
      <label v-show="showAdminContent">Event Details (Add Event)</label>
    </div>

    <div class="info-container">
      <div class="mid-container">
        <div class="inputs">
          <div class="input-container">
            <label>Route Name:</label>
            <input name="name"  v-validate="'required'" v-model="information.name" :class="{'error': errors.has('name') }" type="text" placeholder="Name">
            <span v-show="errors.has('name')" class="error-message">{{ errors.first('name') }}</span>
          </div>
        </div>
      </div>

        <div v-show="!showAdminContent" class="bottom-container">

        </div>
      </div>

      <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Exit" pColor="blue" v-bind:nText="nextText" nColor="green" />

  </div>
</template>

<script>
//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import BottomNav from './BottomNav'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment-timezone'
import axios from 'axios'
import VueMoment from 'vue-moment'

import { userRef } from '../firebase'
import firebase from 'firebase'

import { store } from '../store/store'
import { mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

Vue.use(VueMoment, { moment })

const { mapFields } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
})

function convertDateToUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())
}

export default {
  name: 'information',
  title: 'Runner - Information',
    data() {
      return {
        startError: '',
        endError: '',
        startAmPm: null,
        endAmPm: null
      }
    },
    computed: {
      ...mapFields([
        'information'
      ]),
      ...mapGetters([
        'currentRaceId', 'timezone', 'race'
      ]),
      nextText() {
        return this.showAdminContent ? 'Create Event' : 'Create'
      }
    },
    asyncComputed: {
      showAdminContent() {
        return new Promise((resolve, reject) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (idTokenResult.claims.admin && this.$route.params.addEvent) {
             resolve(true)
           } else {
             resolve(false)
           }
          })
          .catch((error) => {
            console.log(error)
            resolve(false)
          })
        })
      }
    },
    components: {
      BottomNav,
      Datepicker,
      VueTimepicker
    },
  methods: {
    formatTime(event, isStart) {
      console.log(event)
      const { h, mm, a } = event.data
      //if(h && mm) {
        if(isStart) {
          if(h && mm) {
            this.startAmPm = h + ':' + mm + ' ' + a
          }

        } else {
          if(h && mm) {
            this.endAmPm = h + ':' + mm + ' ' + a
          }
        }
    },
    nextPage() {
      this.validateBeforeSubmit()
    },
    previousPage() {
      this.$router.replace('newrace')
    },
    onTrackingChange(value) {
      console.log("tracking changed")
    },
    onNotRaceChange(value) {
      console.log(value)
      if (value === false) {

      } else if (value === true) {
     //  this.information.start = new Date('2035-01-01T00:00:00')
     //  this.information.end = new Date('2035-01-01T18:00:00') //jatka tutkimista
     // console.log(this.information.start)
      }
    },
    submitInfo() {
      console.log("submit info")

      this.startError = ''
      this.endError = ''

      var dates

        dates = {}
        dates.start = 2051222400
        dates.end = 2051287200


      let info = {
        name: this.information.name,
        description: this.information.description,
        notRace: true,
        tracking: true,
        start: dates.start,
        end: dates.end
      }

      if(!this.startError && !this.endError) {
      this.$store.dispatch('submitInformation', info).then(() => {
        if(this.showAdminContent) {
          this.$router.replace({name: 'Alias', params: {'addEvent': true}})
        }
        /*if(this.showAdminContent) {
          //Add event to Events /events
          firebase.auth().currentUser.getIdToken().then((token) => {
            axios({
             method: 'post', //you can set what request you want to be
             //url: 'http://localhost:5000/racepeps/us-central1/eventAdmin/event',
             url: 'https://us-central1-racepeps.cloudfunctions.net/eventAdmin/event',
             data: {'raceId': this.currentRaceId},
             headers: {
               'Authorization': 'Bearer ' + token
             }
            })
            .then(response => {
              console.log(response)
              this.$router.replace('newRace')
            })
            .catch(error => {
              console.log(error)
            })
          })
        }*/

        if(!this.showAdminContent) {
          //this.$router.replace('eventkey')
          //this.$store.dispatch('submitEventKey', Math.random().toString(36).substring(2, 15))

          this.$store.dispatch('submitEventKey', Math.random().toString(36).substring(2, 15)).then(() => {
            this.$router.replace('done')
          })
        }
      })
      }

    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
          if (result) {
            this.submitInfo()
            return;
          }

        //alert('Correct the errors');
      });
    },
    getFormattedDates() {

      //Create the start date object from calendar date and timepicker
      let startTime = this.information.start.date
      startTime.setHours(this.information.start.time.HH)
      startTime.setMinutes(this.information.start.time.mm)

      //Create the end date object from calendar date and timepicker
      let endTime = this.information.end.date
      endTime.setHours(this.information.end.time.HH)
      endTime.setMinutes(this.information.end.time.mm)

      //convert start time to the correct timezone
      var momentStart = moment(startTime)
      momentStart.tz(this.timezone.timeZoneId)
      momentStart.hours(startTime.getHours())
      momentStart.date(startTime.getDate())

      //convert end time to the correct timezone
      var momentEnd = moment(endTime)
      momentEnd.tz(this.timezone.timeZoneId)
      momentEnd.hours(endTime.getHours())
      momentEnd.date(endTime.getDate())

      console.log(momentStart.unix())
      console.log(momentEnd.unix())

      return {start: momentStart.unix(), end: momentEnd.unix()}
    },
  }

}
</script>

<style lang="scss">
  @import '../styles/styles.scss';

</style>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    padding-top: 5%;
    padding-left: 10%;
    padding-right: 10%;
    display: flex;
    flex-direction: column;
  }

  .bottom-container {
    //margin-top: 30px;
    flex: 1;
  }

  .info-text-row {
    display: flex;
    align-items: center;
    padding-left: 10%;
    padding-right: 10%;
    margin-bottom: 20px;
    justify-content: center;
  }

  .info-text {
    font-size: 17px;
    color: $cyan-dark;
  }


  .mid-container .date-row {
    display: flex;
    flex-direction: column;
    //justify-content: space-between;
    width: 100%;
    height: 100px;

    label {
      font-size: $font-medium;
      margin-bottom: 10px;
    }

    .time-detail {
      font-style: italic;
      margin-bottom: 0px;
      font-size: $font-small;
      margin-left: 5px;
    }

    .timezone-detail {
      align-self: flex-end;
      font-size: 14px;
    }

  }

  .date-row.date-row-end {
     margin-top: 10px;
  }

  .mid-container .date-row .date-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5px;

    input {
      margin: 0;
    }
  }

  .toggle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    label {
      margin-right: 20px;
      width: 40%;
    }

    div {
      width: 60%;
    }

  }

  .tracking-row {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    flex: 1;
    padding-left: 10%;
    padding-right: 10%;
    margin-bottom: 30px;
  }

  .tracking-row .tracking-info {
    margin-top: 10px;
  }

  .error {
    border: 2px solid red;
    outline: none;
  }

  .info-container {
  	overflow-y: auto;
  }

  .date-info-desktop {
    display: none;
  }

  .date-info-mobile {

  }

  .date-header {
    flex-direction: row;
    margin-bottom: 10px;

    .date-head {
      margin-right: 10px;
    }
  }

  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 600px;
      height: 480px;
    }

    .bottom-container {
      margin: 0px;
    }

    .inputs {
      flex: 1;
    }

    .dates {
      padding-left: 5%;
    }

    .mid-container {
      flex-direction: row;
      padding: 0% 5% 0% 5%
    }

    .info-text-row {
      padding: 0px 5% 20px 5%;
      margin-bottom: 0px;
    }

    .tracking-row {
      margin-bottom: 0px;
    }

    .date-info-desktop {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
    }

    .date-info-mobile {
      display: none;
    }

    .info-container {
      overflow-y: visible;
    }

    .date-row.date-row-end {
       margin-top: 5px
    }

    .date-header .date-head {
        margin-right: 5px;
    }

  }

</style>
